module.exports = __webpack_public_path__ + "img/login_bj.13322cee.png";